// extracted by mini-css-extract-plugin
export var ServicesWrapper = "Services-module--ServicesWrapper--gM3At";
export var ServicesGrid = "Services-module--ServicesGrid--3s2AE";
export var GridItem = "Services-module--GridItem--1p1h-";
export var ItemLightTheme = "Services-module--ItemLightTheme--3VXr4";
export var ItemDarkTheme = "Services-module--ItemDarkTheme--RQYxi";
export var IconContainer = "Services-module--IconContainer--NTD96";
export var GridItemTextWrapper = "Services-module--GridItemTextWrapper--3Jvdb";